// extracted by mini-css-extract-plugin
export default {"content":"ModalHeader_content__+j6vb","description":"ModalHeader_description__K8BLQ"};